var A={EXTRA_LARGE:"EXTRA_LARGE",LARGE:"LARGE",MEDIUM:"MEDIUM",SMALL:"SMALL"},E=960,L=600,M=428,R=function(R){return R<=M?A.SMALL:R<=L?A.MEDIUM:R<=E?A.LARGE:A.EXTRA_LARGE};export{A as APP_LAYOUT_SIZES,R as getAppDimension};
